import axios from 'axios'

// Create an instance of axios
const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
})

const setAuthHeader = (url: string, token: string | null | undefined) => {
  if (token) {
    // If API belongs to liferay (/o/aapa_jax_rest_services) -> add Bearer
    if (url.includes('/o/aapa_jax_rest_services/')) {
      axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`
    } else {
      axiosInstance.defaults.headers['Authorization'] = token
    }
  } else {
    delete axiosInstance.defaults.headers['Authorization']
  }
}

const httpService = {
  get: (url: string, params = {}, token: string | null | undefined) => {
    setAuthHeader(url, token)
    return axiosInstance.get(url, { params })
  },
  post: (url: string, params = {}, token: string | null | undefined) => {
    setAuthHeader(url, token)
    return axiosInstance.post(url, params)
  },
  patch: (url: string, params = {}, headers = {}) => {
    return axiosInstance.patch(url, params, { headers })
  },
  put: (url: string, params = {}, token: string | null | undefined) => {
    setAuthHeader(url, token)
    return axiosInstance.put(url, params)
  },
  delete: (url: string, params = {}) => {
    return axiosInstance.delete(url, { params })
  },
}

export default httpService
